<script setup>
import axios from 'axios'
import { load } from 'recaptcha-v3'
import { reset } from '@formkit/core'
import { countryList } from '@/bucket/country-list.js'

const runtimeConfig = useRuntimeConfig()

const userData = ref(null)
const loading = ref(false)

const message = ref('')
const messageType = ref('') // 'success' / 'error'

const postinApiId = runtimeConfig.public.postinApiId

const onSubmit = async (formkitData, node) => {
  node.clearErrors()

  loading.value = true

  load(runtimeConfig.public.recaptchaKey).then((recaptcha) => {
    recaptcha.hideBadge()
    recaptcha.execute('postin').then((token) => {
      const formData = new FormData()

      formData.append('captcha', token)
      formData.append('api_id', postinApiId)

      formData.append('name', formkitData.name)
      formData.append('company', formkitData.company)
      formData.append('iva', formkitData.iva)
      formData.append('email', formkitData.email)
      formData.append('phone', formkitData.phone)
      formData.append('country', formkitData.country)
      formData.append('address', formkitData.address)
      formData.append('message', formkitData.message)
      formData.append('terms', formkitData.terms)

      // ID del template mail di postin

      fetch(runtimeConfig.public.postinUrl, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          loading.value = false

          if (response.status === 200) {
            message.value = 'Richiesta di contatto inviata con successo.'
            messageType.value = 'success'
            createAndAddContact(formkitData)
            reset(node)
          } else {
            message.value = 'Invio richiesta di contatto fallita.'
            messageType.value = 'error'
          }
        })
        .catch((e) => {
          loading.value = false
          message.value = 'Invio richiesta di contatto fallita.'
          messageType.value = 'error'
        })

      return { message, messageType }
    })
  })
}

// https://developers.brevo.com/reference/createcontact
// https://developers.brevo.com/reference/addcontacttolist-1

async function createAndAddContact(formkitData) {
  return await $fetch('/api/brevo', {
    method: 'POST',
    body: {
      email: formkitData.email,
      attributes: formkitData.attributes || {},
    },
  })
}
</script>

<template>
  <div class="form-contact">
    <!-- eslint-disable vue/no-v-html -->
    <FormKit
      id="requestForm"
      v-model="userData"
      type="form"
      :actions="false"
      @submit="onSubmit"
    >
      <div class="form-contact__grid">
        <!-- Nome -->
        <FormKit
          type="text"
          name="name"
          label="Nome"
          validation="required"
          placeholder="Ad esempio, Mario Rossi"
        />

        <!-- Azienda -->
        <FormKit
          type="text"
          name="company"
          label="Azienda"
          validation="required"
        />

        <!-- P.IVA -->
        <FormKit type="text" name="iva" label="Partita IVA" />

        <!-- Email -->
        <FormKit
          type="email"
          name="email"
          label="Email"
          validation="required|email"
        />

        <!-- Telephone -->
        <FormKit type="text" name="phone" label="Telefono o Whatsapp" />

        <!-- Paese  -->
        <FormKit
          type="select"
          select-icon="down"
          label="Paese"
          placeholder="---"
          name="country"
          :options="countryList"
        />

        <!-- Indirizzo -->
        <FormKit
          type="text"
          name="address"
          label="Indirizzo"
          placeholder="Ad esempio, Via padova, 35B"
        />

        <!-- Messaggio -->
        <FormKit type="textarea" name="message" label="Messaggio" rows="7" />
      </div>
      <!-- CHECKBOX -->
      <FormKit
        type="checkbox"
        name="terms"
        validation="accepted"
        :validation-messages="{ accepted: $t('form.termsError') }"
      >
        <template #label>
          <div class="privacy">
            {{ $t('form.termsExtLabelPart1')
            }}<nuxt-link
              :to="$localePath({ name: 'privacy-policy' })"
              class="link-underline-1"
            >
              {{ $t('form.termsLabelLinkText') }} </nuxt-link
            >,
            {{ $t('form.termsExtLabelPart2') }}
          </div>
        </template>
      </FormKit>
      <div class="form-contact__cta">
        <button type="submit" class="form-contact__submit">
          Invia richiesta
        </button>
      </div>
      <div v-if="message" :class="[messageType]" class="result-message text-2">
        {{ message }}
      </div>
    </FormKit>
  </div>
</template>

<script>
export default {
  name: 'FormContact',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
